import axiosInstance from './axiosInstance';

export const get = async (url, config = {}) => {
  try {
    const response = await axiosInstance.get(url, config);
    return response.data;
  } catch (error) {
    console.error('GET request failed:', error);
    throw error;
  }
};

export const post = async (url, data, config = {}) => {
  try {
    const defaultConfig = {
      headers: {
        'Content-Type': 'application/json',
        ...config.headers,
      },
    };

    const response = await axiosInstance.post(url, data, {
      ...defaultConfig,
      ...config,
    });

    return response.data;
  } catch (error) {
    console.error('POST request failed:', error);
    throw error;
  }
};
